import { PageHeader } from "@/components/page";
import { CreateUserDialog } from "@/components/users/CreateUserDialog";
import { ImportUsersDialog } from "@/components/users/ImportUsersDialog";
import { UsersTable } from "@/components/users/UsersTable";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { messageService } from "@/services/messageService/clientMessageService";
import type { UserWRole } from "@repo/types";
import { DataTableWrapper } from "@repo/ui/components/Base/DataTable";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const UsersPage = () => {
  const { tenantId } = useParams();
  useRoleProtected("admin");
  const { loaded: tenantLoaded, data: tenantData } = useGetTenantByFriendly(
    tenantId ?? ""
  );
  useEffect(() => {
    const mService = messageService.getInstance();

    const sub = mService.subscribe("test1", [], (message) => {
      if (message.data) {
        const user = message.data.auth;
        console.log("User test message received:", user);
      } else {
        console.log("Test message received:", message);
      }
    });
    return () => {
      sub?.unsubscribe();
    };
  }, []);
  const [editUser, setEditUser] = useState<UserWRole | null>(null);

  const onUserCreated = (user: UserWRole) => {
    setEditUser(user);
  };

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader
        title={tenantData?.name ? `${tenantData.name}'s Users` : "Users"}
        className="gap-x-4"
      >
        <div className="flex flex-row gap-1">
          {tenantData?.id && <ImportUsersDialog tenantId={tenantData.id} />}
          {tenantData?.id && (
            <CreateUserDialog
              tenantId={tenantData.id}
              onCreated={onUserCreated}
            />
          )}
        </div>
      </PageHeader>

      {!tenantLoaded && <div>Loading ... </div>}

      {tenantLoaded && tenantData?.id && (
        <DataTableWrapper>
          <UsersTable
            tenantId={tenantData?.id}
            editUser={editUser}
            resetEditUser={() => setEditUser(null)}
          />
        </DataTableWrapper>
      )}
    </div>
  );
};
